/**************************************************
 * Nombre:       Login
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography, useMediaQuery} from "@mui/material";
import {useFormulario} from "../Modulo_formularios/Hooks/useFormulario";
import Formulario_Login from "./Formulario_Login";
import {theme} from "../Tema";
import './login.css'
import {useCargador} from "../Modulo_Cargador/Hooks/useCargador";
import {Check} from '@mui/icons-material'
import {funIngresarCorreoPass} from "../Servicios/Auth/funIngresarCorreoPass";
import {funRecuperarContrasena} from "../Servicios/Auth/funRecuperarContrasena";

const Login = ({logo, logoRedondo}) => {
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))
    const masSM = useMediaQuery(theme.breakpoints.up('md'))
    const {props, obtenerEntidad, limpiarEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, iniciarCarga, Avisos, nuevoAviso, terminar} = useCargador({logoRedondo: logoRedondo})


    const ingresar = async () => {

        iniciarCarga('Enviano mail')
        let entidad = await obtenerEntidad()
        await funIngresarCorreoPass(entidad.correo, entidad.pass)
        terminar({aviso: 'Ingresos realizado'})

    }

    const recuperarContra = async () => {


        let entidad = await obtenerEntidad()

        await funRecuperarContrasena(entidad.correo)


    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            size={12}
            sx={{backgroundColor: '#fff'}}
        >

            <Cargador/>

            <Avisos/>

            <Typography sx={{position: 'fixed', right: 12, bottom: 8}}>v 0.1.1</Typography>


            <Grid container size={{xs: 12, sm: 5, md: 7}} className={masSM ? 'clase' : 'claseCell'}
                  sx={{justifyContent: 'center', py: 6, backgroundColor: '#000', minHeight: sCell ? '30vh' : '100vh'}}>
                <img src={logo} width={'40%'} height={'auto'} alt={'Logo empresa'} title={'Logo'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 7, md: 5}} sx={{justifyContent: 'center'}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems="center"
                    size={12}
                    sx={{backgroundColor: '#fff', minHeight: sCell ? '45vh' : '100vh', px: sCell ? 4 : 0}}
                >


                    <Grid container size={{xs: 12, sm: 9, md: 8}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            spacing={2}
                            sx={{py: 8,}}
                        >

                            <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 32, fontWeight: 800, px: 1}}>Hola!</Typography>
                            </Grid>

                            <Grid container size={12}
                                  sx={{justifyContent: 'flex-start', marginTop: -2}}>
                                <Typography sx={{fontSize: 16, fontWeight: 300, px: 1}}>Accede al panel de
                                    control</Typography>
                            </Grid>


                            <Grid container size={12}
                                  sx={{justifyContent: 'flex-start', marginTop: -2}}>
                                <Formulario_Login props={props}/>
                            </Grid>

                            <Grid container size={12} sx={{justifyContent: 'flex-end', px: 1}}>
                                <Button
                                    onClick={() => recuperarContra()}
                                    variant={'text'} sx={{px: 0}}>Olvide mi contraseña</Button>
                            </Grid>

                            <Grid container size={12} sx={{justifyContent: 'center', px: 1}}>
                                <Button
                                    startIcon={<Check/>}
                                    onClick={() => ingresar()}
                                    variant={'outlined'} sx={{px: 4}}>Ingresar</Button>
                            </Grid>


                        </Grid>
                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Login    